// import { validateUrls } from "api/types"   ?????
import { getServiceURL } from "api/utils"
import { SERVICE_PREFIX } from "utils/constants"

const getPerseusURL = getServiceURL(SERVICE_PREFIX.perseus)
const getPhoenixURL = getServiceURL(SERVICE_PREFIX.phoenix)

export const urls = {
  getAttempt: (assessmentId: number | string) =>
    getPerseusURL(`/v1/assessments/cpat/${assessmentId}/attempts/`),
  assessment: (attemptId: number | string) =>
    getPerseusURL(`/v1/assessments/cpat/attempts/${attemptId}/start/`),
  markAnswer: (questionId: number | string) =>
    getPerseusURL(
      `/v1/assessments/cpat/temp-attempt-question-responses/${questionId}/`
    ),
  validateImage: () => "/umbra/v1/proctoring/validate-image/",
  submitAssessment: (attemptId: number | string) =>
    getPerseusURL(`/v1/assessments/cpat/attempts/${attemptId}/submit/`),
  getReports: () => getPhoenixURL("/v1/credentials/"),
  getAttemptWarning: (attemptId: number | string) =>
    getPerseusURL(`/v1/extras/attempt-warning/${attemptId}/`),
  uploadViolation: () => "/umbra/v1/proctoring/images/",
  retrieveProctoringResults: (attemptId: number | string) =>
    `/umbra/v1/proctoring/results/${attemptId}/`,
  updateWarningCount: (attemptId: number | string) =>
    getPerseusURL(`/v1/extras/attempt-warning/${attemptId}/`),
  enrollCpat: slug => `/nova/v1/enrollments/cpat/${slug}/`,
}
